// Floating autocomplete shown above the composer for @mentions,
// #channels, ##tickets, @@events, and +references.

export const ChatMentionDropdown = {
  hide: (el, s) => !(s && s.root && s.root.mentionPicker && (s.root.mentionPicker.options || []).length > 0),
  position: 'fixed',
  zIndex: 2050,
  flow: 'y',
  width: 'G',
  maxHeight: 'F',
  round: 'Z',
  theme: 'modal',
  borderWidth: '1px',
  borderColor: 'line',
  borderStyle: 'solid',
  boxShadow: '0 8px 24px var(--color-shadow)',
  overflow: 'auto',
  bottom: (el, s) => {
    const picker = s && s.root && s.root.mentionPicker
    if (!picker) return 'auto'
    const editorBottom = typeof window !== 'undefined' ? window.innerHeight - (picker.top + 240) : 100
    return `${Math.max(8, editorBottom)}px`
  },
  left: (el, s) => (s && s.root && s.root.mentionPicker) ? `${Math.max(8, s.root.mentionPicker.left)}px` : '0',

  childExtends: 'ChatMentionRow',
  childrenAs: 'state',
  children: (el, s) => {
    const picker = s && s.root && s.root.mentionPicker
    if (!picker || !picker.options) return []
    return picker.options.map((p, i) => ({
      ...p,
      _idx: i,
      _active: i === (picker.activeIndex || 0),
      _pickerType: picker.type || 'person'
    }))
  }
}

export const ChatMentionRow = {
  flow: 'x',
  align: 'center left',
  gap: 'Z',
  padding: 'Y2 Z',
  cursor: 'pointer',
  round: 'Z',
  background: (el, s) => (s && s._active) ? 'overlay' : 'transparent',
  ':hover': { background: 'overlay' },
  attr: {
    'data-mention-pick': (el, s) => {
      if (!s) return ''
      const t = s._pickerType
      if (t === 'person') return s.email || ''
      if (t === 'channel') return s.name || ''
      if (t === 'ticket') return String(s.number || s.id || '')
      if (t === 'event') return s.title || ''
      if (t === 'reference') return s.title || ''
      return ''
    }
  },

  Icon_prefix: {
    tag: 'span',
    fontSize: 'Z2',
    color: 'caption',
    fontWeight: '600',
    display: (el, s) => (s && s._pickerType !== 'person') ? 'inline' : 'none',
    text: (el, s) => {
      if (!s) return ''
      const t = s._pickerType
      if (t === 'channel') return '#'
      if (t === 'ticket') return '##'
      if (t === 'event') return '@@'
      if (t === 'reference') return '+'
      return ''
    }
  },

  Avatar: {
    display: (el, s) => (s && s._pickerType === 'person') ? 'flex' : 'none',
    avatarType: 'initials',
    boxSize: 'A1 A1',
    src: (el, s) => el.call('avatarUrl', s && s.name)
  },

  Info: {
    flow: 'y',
    gap: 'V',
    flex: '1',
    minWidth: '0',
    Name: {
      tag: 'span',
      fontSize: 'Z2',
      color: 'title',
      fontWeight: '600',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      text: (el, s) => {
        if (!s) return ''
        const t = s._pickerType
        if (t === 'person') return s.name || ''
        if (t === 'channel') return s.name || ''
        if (t === 'ticket') return (s.number ? `#${s.number} · ` : '') + (s.title || '')
        if (t === 'event') return s.title || ''
        if (t === 'reference') return s.title || ''
        return s.name || s.title || ''
      }
    },
    Detail: {
      tag: 'span',
      fontSize: 'Y2',
      color: 'caption',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      text: (el, s) => {
        if (!s) return ''
        const t = s._pickerType
        if (t === 'person') return s.email ? '@' + s.email.split('@')[0] : ''
        if (t === 'channel') return s.topic || ''
        if (t === 'ticket') return s.state || s.column_key || ''
        if (t === 'event') return s.date || ''
        if (t === 'reference') return s._refType || ''
        return ''
      },
      display: (el, s) => {
        if (!s) return 'none'
        const t = s._pickerType
        if (t === 'person') return s.email ? 'block' : 'none'
        if (t === 'channel') return s.topic ? 'block' : 'none'
        return 'block'
      }
    }
  }
}
